import AlertDefinitionsPage from "../../pages/system/alerts/AlertDefinitionsPage";

const route = {
  key: "alertDefinitions",
  path: "/system/alerts",
  component: AlertDefinitionsPage,
  permission: "alerts.read",
  private: true,
  layout: "main",
  icon: "faBell",
  group: "system",
  order: 50
};

export default route;
